import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WhatsNewItemData } from '../../generated/WhatsNewItem';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWhatsNewFeedQueryVariables = Types.Exact<{
  page: Types.PageInput;
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type GetWhatsNewFeedQuery = { __typename?: 'Query', whatsNewFeed?: { __typename?: 'WhatsNewFeed', lastUpdated?: string | null, items?: { __typename?: 'WhatsNewItemConnection', totalCount: number, nodes: Array<{ __typename?: 'WhatsNewItem', availability?: string | null, date?: string | null, description?: string | null, id?: string | null, imageUrl?: string | null, link?: string | null, title?: string | null, type?: string | null }> } | null } | null };


export const GetWhatsNewFeed = /*#__PURE__*/ gql`
    query GetWhatsNewFeed($page: PageInput!, $locale: SupportedLocale) {
  whatsNewFeed(locale: $locale) {
    lastUpdated
    items(page: $page) {
      totalCount
      nodes {
        ...WhatsNewItemData
      }
    }
  }
}
    ${WhatsNewItemData}` as unknown as DocumentNode<GetWhatsNewFeedQuery, GetWhatsNewFeedQueryVariables>;

          

          export const useGetWhatsNewFeedQuery = (options?:QueryHookOptions<GetWhatsNewFeedQuery, GetWhatsNewFeedQueryVariables>) => useQuery(GetWhatsNewFeed, options);

          

          export type GetWhatsNewFeedQueryOptions = QueryHookOptions<GetWhatsNewFeedQuery, GetWhatsNewFeedQueryVariables>;

          

          export const useGetWhatsNewFeedLazyQuery = (options?:LazyQueryHookOptions<GetWhatsNewFeedQuery, GetWhatsNewFeedQueryVariables>) => useLazyQuery(GetWhatsNewFeed, options);

          

          export type GetWhatsNewFeedQueryResult = ReturnType<typeof useGetWhatsNewFeedQuery>;

          
